<!-- 
  public const short Master = 1;
  public const short DirectMaster = 2;
  public const short Direct = 3;
  public const short SingleKeyDifferentMaster = 4;
  public const short SingleKeyDifferent = 5;
  public const short Change = 6;
  public const short SelectiveMaster = 7;
-->

<div
  *ngIf="hierarchyItem"
  class="master-key"
  [ngClass]="{
    'change-key':
      hierarchyItem?.isChangeKey ||
      hierarchyItem?.masterKeyType?.name === 'DirectChangeMaster' ||
      hierarchyItem?.masterKeyType?.name === 'Direct' ||
      hierarchyItem?.masterKeyTypeId === 99,
    skd:
      hierarchyItem?.masterKeyType?.name === 'SingleKeyDifferentMaster' ||
      hierarchyItem?.masterKeyType?.name === 'SingleKeyDifferent' ||
      hierarchyItem?.masterKeyTypeId === 100,
    slm: hierarchyItem?.masterKeyType?.name === 'SelectiveMaster',
    dc: hierarchyItem?.masterKeyType?.name === 'DirectChangeMaster',
    selectable: selectedMasterKey && !disabled,
    selected: selectedMasterKey?.id === hierarchyItem?.id,
    'key-disabled': disabled
  }"
>
  <div *ngIf="hasMinimize(hierarchyItem)">
    <mat-icon
      class="minimize"
      (click)="toggleMinimized()"
      *ngIf="(!hierarchyItem.isMinimized && !hierarchyItem.isChangeKey && hierarchyItem?.children?.length && !hierarchyItem.isTMK) || (hierarchyItem.isTMK && !hierarchyItem.showMinimizedIcon)"
    >arrow_drop_down</mat-icon>
    <mat-icon
      class="minimize"
      (click)="toggleMinimized()"
      *ngIf="(hierarchyItem.isMinimized && !hierarchyItem.isChangeKey && hierarchyItem?.children?.length) || (hierarchyItem.isTMK && hierarchyItem.showMinimizedIcon)"
    >arrow_drop_up</mat-icon>
  </div>

  <ng-content></ng-content>

  <div *ngIf="limitSize" class="limit-size padding sm left right">
    {{ replace(hierarchyItem.keySetSymbol) }}
  </div>

  <div *ngIf="!limitSize" class="symbol-text padding sm left right">
    {{ hierarchyItem.keySetSymbol }}
  </div>

  <mat-icon
    class="key-icon"
    *ngIf="hierarchyItem.openingCylinderOperators?.length > 0"
    [matTooltip]="
      'To delete this master, it must be removed from all cross keyed cylinders, as well as any children of this master.'
    "
  >
    vpn_key
  </mat-icon>
</div>
